import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import { ReactNode } from 'react';

const ITEM_VALUE = 'section';

/** Open state of a collapsible part – owned by the form, so it can open the parts that hold errors. */
export interface CollapsiblePanelProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export interface OfferFormSectionProps {
  title: string;
  description?: string;
  panel: CollapsiblePanelProps;
  children: ReactNode;
}

/** Card around one block of the offer form (CI card pattern), collapsible by its header. */
const OfferFormSection = ({ title, description, panel, children }: OfferFormSectionProps) => (
  <AccordionPrimitive.Root
    type="single"
    collapsible
    value={panel.isOpen ? ITEM_VALUE : ''}
    onValueChange={(value) => panel.onOpenChange(value === ITEM_VALUE)}
    className="rounded-2xl border border-[#E4E7EC] bg-white p-6">
    <AccordionPrimitive.Item value={ITEM_VALUE}>
      <AccordionPrimitive.Header>
        <AccordionPrimitive.Trigger className="group flex w-full items-start justify-between gap-4 text-left">
          <span className="flex flex-col gap-1">
            <span className="text-[18px] font-bold text-[#12282A]">{title}</span>
            {description && <span className="text-[12px] text-[#888]">{description}</span>}
          </span>
          <ChevronDown className="mt-1 h-5 w-5 shrink-0 text-[#888] transition-transform duration-200 group-data-[state=open]:rotate-180" />
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
      {/* Room for the inputs' focus ring – the overflow needed by the animation would cut it off at the edges. */}
      <AccordionPrimitive.Content className="-mx-1 overflow-hidden px-1 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        <div className="flex flex-col gap-5 pb-1 pt-5">{children}</div>
      </AccordionPrimitive.Content>
    </AccordionPrimitive.Item>
  </AccordionPrimitive.Root>
);

export default OfferFormSection;
